import { useRef } from "react";

import { NotificationType } from "@/apollo/types";

export type WorkspaceAlert = {
  id: string;
  type?: NotificationType;
  updatedAt?: Date;
  status: "info" | "warning" | "error";
  title?: string;
  message: React.ReactNode;
  action?: React.ReactNode;
  /** The banner can be dismissed by the user - either permanently or for a certain duration. Dismissal state is stored in localStorage. */
  isDismissible?: boolean;
  /** How long the dismissal lasts in ms. Undefined = permanent. */
  dismissDuration?: number;
  onDismiss?: () => void;
  alwaysShow?: boolean;
  render?: (props: { dismiss: () => void }) => JSX.Element;
};

export type WorkspaceAlertResolver = () => WorkspaceAlert[];

export function useWorkspaceAlerts(...resolvers: WorkspaceAlertResolver[]) {
  const resolversRef = useRef(resolvers);
  if (resolversRef.current.length !== resolvers.length) {
    throw new Error("Cannot change the number of resolvers");
  }

  const alerts: WorkspaceAlert[] = [];
  for (const resolver of resolvers) {
    alerts.push(...resolver());
  }

  return alerts;
}
